const getUrlParam = (parameter:string):string => {
  const pageURL = window.location.search;
  const regex = new RegExp(`${parameter}=([^&]*)`)
  const param = pageURL.match(regex);
  return param ? param[1] : (parameter === 'id' ? "default" : "");
};

export default getUrlParam;
